import { Theme, useMediaQuery, useTheme } from "@mui/material";

import { DesktopToggleCard } from "./DesktopToggleCard";
import { MobileToggleCard } from "./MobileToggleCard";
import { ToggleCardProps } from "./types";

export function FormToggleCard({ customizable, ...props }: ToggleCardProps) {
  const fullProps = {
    ...props,
    customizable: customizable ?? true,
  };

  const theme = useTheme();

  const isMobileView = useMediaQuery<Theme>(theme.breakpoints.down("md"));

  if (isMobileView) return <MobileToggleCard {...fullProps} />;

  return <DesktopToggleCard {...fullProps} />;
}
